import {gql} from '@apollo/client'

export const UPDATE_PREFERENCES = gql`
  mutation UpdatePreferences($input: PreferencesInput!) {
    updatePreferences(input: $input) {
      id
      preferences {
        driveView
        lockedHidden
        lockedResealAfter
      }
    }
  }
`
